import {environment} from '../../../environments/environment';
import {Settings} from '@lv1871/core';

export function settingsFactory(): Settings {
  return environment;
}
